import { FONT_WEIGHT_BOLD, FONT_WEIGHT_REGULAR, media } from '../../styles';
import styled from 'styled-components';

type Props = {
  isMobile: boolean;
};

export const TabList = styled.div<Props>`
  background-color: ${({ theme }) => theme.ui.layer.backgroundColor};
  border-bottom: 1px solid ${({ theme }) => theme.ui.secondLayer.dividers};
  padding: ${({ theme }) => `${theme.spacing.base.xxs} ${theme.spacing.base.xl} 0`};
  top: -2px;
  z-index: 2147483641;
  position: sticky;
  position: -webkit-sticky;
  width: 100%;
  &.sticky-tab {
    position: fixed;
  }
`;

export const Tab = styled.button<{ active: boolean }>`
  background-color: ${({ theme }) => theme.ui.layer.backgroundColor};
  border: none;
  border-bottom: ${({ active, theme }) => (active ? ` 2px solid ${theme.ui.tabs.color}` : ` none`)};
  color: ${({ theme, active }) => (active ? theme.ui.tabs.color : theme.ui.text.color)};
  cursor: pointer;
  font: inherit;
  font-size: ${({ theme }) => theme.typography.size.medium};
  font-weight: ${({ active }) => (active ? FONT_WEIGHT_BOLD : FONT_WEIGHT_REGULAR)};
  outline: none;
  padding: ${({ theme }) => `${theme.spacing.base.xs} 0`};
  width: 50%;

  ${media.mobilePortrait} {
    padding-bottom: ${({ theme }) => theme.spacing.base.md};
  }

  &:focus-visible {
    outline-style: auto;
    outline-width: 5px;
  }
`;

export const TabPanel = styled.div<{ active: boolean }>`
  background-color: ${({ theme }) => theme.ui.secondLayer.content.backgroundColor};
  display: ${({ active }) => (active ? 'flex' : 'none')};
  flex: 1 1 auto;
  outline: none;

  ${media.mobilePortrait} {
    flex: 1 1 auto;
  }
`;

const getFadingStyle = (backgroundColor: string): string => `
&:before {
  background: linear-gradient(180deg, ${backgroundColor} 0%, rgba(255, 255, 255, 0) 100%);
  content: '';
  display: block;
  height: 20px;
  left: 0;
  pointer-events: none;
  position: absolute;
  right: 0;
  width: 100%;
  z-index: 10;
  ${media.ie11} {
    display: none !important;
  }
`;

export const TabPanelContainer = styled.div<{ withFadingTop: boolean }>`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 100%;
  height: inherit;
  overflow: hidden;
  width: 100%;
  padding-top: 0px;
  ${({ withFadingTop, theme }): string =>
    withFadingTop ? getFadingStyle(theme.ui.secondLayer.content.backgroundColor) : ''};
`;

export const TabPanelTitle = styled.div`
  font-size: ${({ theme }) => theme.typography.size.medium};
  font-weight: ${({ theme }) => theme.typography.weight.bold};
  margin: ${({ theme }) => `${theme.spacing.base.sm} 0`};
`;
